import * as React from 'react';
import rewardPlaceholder from '../../../assets/reward-placeholder.svg';
import './progress-block-tier.styles.less';
import { getModeClass } from 'utils/css';

export const ProgressBlockTier: React.FC<IProps> = ({
    title,
    imageSrc,
    shouldInheritStyles,
    onClick
}) => {
    const basePageStyleClass = getModeClass('sitegen-friend-referral-progress-tier', shouldInheritStyles);
    return (
        <div className={basePageStyleClass} onClick={onClick}>
            <img className={`${basePageStyleClass}__img`}
                src={ imageSrc || rewardPlaceholder }
            />

            <div className={`${basePageStyleClass}__title`}>
                { title }
            </div>
        </div>
    );
};

interface IProps {
    title: React.ReactNode;
    imageSrc?: string;
    onClick: () => void;
    shouldInheritStyles: boolean;
}

export {
    IProps,
    rewardPlaceholder
};
